import { DHElementsData, DHElementsTco, DHTco } from '../../../types/design-huddle.types'

export const buildUpdatedTco = (data: DHElementsData, currentTco: DHTco): DHElementsTco => {
  const elementClassToIdsMap: Record<string, string[]> = {}
  const updatedTco: DHElementsTco = {
    elements: {}
  }

  for (const pageIdx in data.pages) {
    const page = data.pages[pageIdx]
    for (const elementId in page.elements) {
      const element = page.elements[elementId]
      for (const classIdx in element.element_classes) {
        const className = element.element_classes[classIdx]
        const existing_ids = elementClassToIdsMap[className] || []
        existing_ids.push(elementId)
        elementClassToIdsMap[className] = existing_ids
      }
    }
  }

  for (const key in currentTco) {
    if (elementClassToIdsMap[key]) {
      const elementId = elementClassToIdsMap[key][0]
      if (elementId) {
        updatedTco.elements[elementId] = currentTco[key]
      }
    }
  }

  return updatedTco
}
